import { convertAmount } from "./money";

const normalizeCurrencyCode = (value) => {
  const code = String(value || "").trim().toUpperCase();
  return /^[A-Z]{3}$/.test(code) ? code : "";
};

const finiteNumber = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export const getOrderTransactionCurrency = (order) =>
  normalizeCurrencyCode(
    order?.paidCurrency ||
    order?.settlement?.currency ||
    order?.paymentResult?.currency ||
    order?.currency ||
    order?.items?.[0]?.currency
  ) || "USD";

export const resolveOrderUsdValue = (order, rates) => {
  const auditedAmount = finiteNumber(order?.accountingUsd?.amount);
  if (auditedAmount !== null) {
    const classification =
      String(order?.accountingUsd?.classification || "").trim() ||
      "manual_correction";
    return {
      amount: auditedAmount,
      source: classification,
      auditSource: String(order?.accountingUsd?.source || "").trim(),
    };
  }

  const storedBaseTotal = finiteNumber(order?.baseTotalPrice);
  if (storedBaseTotal !== null) {
    return { amount: storedBaseTotal, source: "stored_base_total" };
  }

  const currency = getOrderTransactionCurrency(order);
  const total = finiteNumber(order?.totalPrice ?? order?.total) ?? 0;
  if (currency === "USD") {
    return { amount: total, source: "usd_transaction" };
  }

  const snapshotCurrency = normalizeCurrencyCode(
    order?.exchangeRateSnapshot?.transactionCurrency
  );
  const rateCandidates = [
    {
      rate: finiteNumber(order?.paidExchangeRate),
      currency: normalizeCurrencyCode(order?.paidCurrency),
    },
    {
      rate: finiteNumber(order?.exchangeRateSnapshot?.rate),
      currency: snapshotCurrency,
    },
    {
      rate: finiteNumber(order?.exchangeRate),
      currency: normalizeCurrencyCode(order?.currency),
    },
  ];
  const lockedRate = rateCandidates.find(
    (candidate) =>
      candidate.rate > 0 &&
      (!candidate.currency || candidate.currency === currency)
  )?.rate;
  if (lockedRate) {
    return {
      amount: Math.round(((total / lockedRate) + Number.EPSILON) * 100) / 100,
      source: "locked_exchange_rate",
    };
  }

  if (order?.isPaid) {
    return { amount: null, source: "missing_historical_rate" };
  }

  try {
    return {
      amount: convertAmount(total, {
        from: currency,
        to: "USD",
        rates,
      }),
      source: "current_rate_estimate",
    };
  } catch {
    return { amount: null, source: "rate_unavailable" };
  }
};
